import gql from "graphql-tag";

export const MY_HR_GET_PAY_OFFICES = gql`
  query payOffices(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
    $payOffices: [String]
    $product: String
    $role: String
    $showAllowedEntities: Boolean
  ) {
    payOffices(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
      payOffices: $payOffices
      product: $product
      role: $role
      showAllowedEntities: $showAllowedEntities
    ) {
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
